var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 30,
    height: 30,
    rx: 12,
    fill: "#1A1F37"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 14V11.5C17 11.0404 17.0905 10.5852 17.2664 10.1606C17.4423 9.73597 17.7001 9.35013 18.0251 9.02513C18.3501 8.70012 18.736 8.44231 19.1606 8.26642C19.5852 8.09053 20.0404 8 20.5 8C20.9596 8 21.4148 8.09053 21.8394 8.26642C22.264 8.44231 22.6499 8.70012 22.9749 9.02513C23.2999 9.35013 23.5577 9.73597 23.7336 10.1606C23.9095 10.5852 24 11.0404 24 11.5V14H25.5C25.8978 14 26.2794 14.158 26.5607 14.4393C26.842 14.7206 27 15.1022 27 15.5V16.05C27.5651 16.1648 28.0732 16.4714 28.4382 16.9179C28.8031 17.3644 29.0025 17.9233 29.0025 18.5C29.0025 19.0767 28.8031 19.6356 28.4382 20.0821C28.0732 20.5286 27.5651 20.8352 27 20.95V21.5C27 21.8978 26.842 22.2794 26.5607 22.5607C26.2794 22.842 25.8978 23 25.5 23H15.5C15.1022 23 14.7206 22.842 14.4393 22.5607C14.158 22.2794 14 21.8978 14 21.5V15.5C14 15.1022 14.158 14.7206 14.4393 14.4393C14.7206 14.158 15.1022 14 15.5 14H17ZM18 11.5C18 10.837 18.2634 10.2011 18.7322 9.73223C19.2011 9.26339 19.837 9 20.5 9C21.163 9 21.7989 9.26339 22.2678 9.73223C22.7366 10.2011 23 10.837 23 11.5V14H18V11.5ZM22.5 17C22.1022 17 21.7206 17.158 21.4393 17.4393C21.158 17.7206 21 18.1022 21 18.5C21 18.8978 21.158 19.2794 21.4393 19.5607C21.7206 19.842 22.1022 20 22.5 20H26.5C26.8978 20 27.2794 19.842 27.5607 19.5607C27.842 19.2794 28 18.8978 28 18.5C28 18.1022 27.842 17.7206 27.5607 17.4393C27.2794 17.158 26.8978 17 26.5 17H22.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19H24V18H25V19ZM22 19H23V18H22V19ZM27 19H26V18H27V19Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_10",
    x: 0.5,
    y: -2.38419e-7,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_10"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_10",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeIcon);
export default __webpack_public_path__ + "static/media/changeIcon.7113a51b394570c51857fe636655ad72.svg";
export { ForwardRef as ReactComponent };